import { defineMessages } from 'react-intl';

const translations = {
  emptyMessage: {
    id: 'putawayList.emptyMessage',
    defaultMessage: 'No items available',
    description: 'Empty message of the put away list',
  },
};

export default defineMessages(translations);
